module.exports = __webpack_public_path__ + "static/media/svgskilt_finishstopp-trackpoi_finish.4808df8c.svg";